export const siteUrl = process.env.VUE_APP_SITE_URL;
export const environment = process.env.NODE_ENVIRONMENT;
